import { format } from 'date-fns';
import { AXIS_LABEL_DATE_FORMAT, AXIS_LABEL_DATE_FORMAT_LONG, COLORS, WHITE_COLOR, MONTHLY_INTERVAL, PAGE_BG_COLOR, GRID_LINE_COLOR, DEFAULT_OPTIONS, TOOLTIP_BACKGROUND, } from '../constants';
import { formatNumberToDp } from './formatNumberToDp';
export const getCustomOptions = () => (Object.assign(Object.assign({}, DEFAULT_OPTIONS), { chart: {
        backgroundColor: PAGE_BG_COLOR,
        plotBorderColor: GRID_LINE_COLOR,
        plotBorderWidth: 1,
    }, title: { text: undefined }, tooltip: {
        padding: 15,
        backgroundColor: TOOLTIP_BACKGROUND,
        style: {
            color: WHITE_COLOR,
        },
        formatter() {
            return `${format(this.point.x, AXIS_LABEL_DATE_FORMAT_LONG)}<br />Value: ${formatNumberToDp(this.point.y, 2)}`;
        },
    }, legend: { enabled: false }, colors: COLORS, series: [
        {
            type: 'area',
            pointInterval: 24 * 3600 * 1000,
            marker: {
                enabled: false,
            },
        },
    ], yAxis: {
        gridLineColor: GRID_LINE_COLOR,
        title: {
            text: 'Rate',
            style: { color: WHITE_COLOR, opacity: 0.7 },
        },
    }, xAxis: {
        type: 'datetime',
        tickInterval: MONTHLY_INTERVAL,
        gridLineColor: GRID_LINE_COLOR,
        gridLineWidth: 1,
        tickLength: 20,
        tickWidth: 0,
        tickmarkPlacement: 'between',
        lineWidth: 0,
        labels: {
            style: { color: WHITE_COLOR, opacity: 0.7 },
            formatter: (item) => format(new Date(item.value), AXIS_LABEL_DATE_FORMAT),
        },
    } }));
//# sourceMappingURL=getCustomOptions.js.map